import { Download } from 'lucide-react';
import { Modal } from './Modal';

export type PdfPronto = { url: string; arquivo: string; fotosFalharam: number };

// Janela "PDF pronto": o download sai do botao, que e' um clique novo. Usada quando o navegador
// nao tem o "Salvar como" (lib/salvar-pdf.ts) ou a gravacao no arquivo escolhido falhou.
// Quem abre e' dono da URL do blob; fechar ou baixar a revoga.
export function ModalPdfPronto({ pdf, onFechar }: { pdf: PdfPronto | null; onFechar: () => void }) {
  function fechar() {
    if (pdf) URL.revokeObjectURL(pdf.url);
    onFechar();
  }

  function baixar() {
    if (!pdf) return;
    const a = document.createElement('a');
    a.href = pdf.url;
    a.download = pdf.arquivo;
    // Anexar ao DOM antes do click (Firefox) e revogar depois de um tempo (revogar na mesma
    // pilha cancela o download).
    document.body.appendChild(a);
    a.click();
    a.remove();
    const url = pdf.url;
    setTimeout(() => URL.revokeObjectURL(url), 10000);
    onFechar();
  }

  return (
    <Modal
      aberto={!!pdf}
      onFechar={fechar}
      titulo="PDF pronto"
      largura={440}
      rodape={
        <>
          <button type="button" className="btn-secundario" onClick={fechar}>Fechar</button>
          <button type="button" className="btn-primario" onClick={baixar} autoFocus style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
            <Download size={14} /> Baixar PDF
          </button>
        </>
      }
    >
      <div style={{ fontSize: 14, wordBreak: 'break-word' }}>{pdf?.arquivo}</div>
      {!!pdf?.fotosFalharam && (
        <div style={{ marginTop: 12, padding: '8px 12px', borderRadius: 6, background: '#fde68a', color: '#000', fontSize: 13, fontWeight: 600 }}>
          {pdf.fotosFalharam === 1 ? '1 foto nao carregou' : `${pdf.fotosFalharam} fotos nao carregaram`} — confira antes de enviar.
        </div>
      )}
    </Modal>
  );
}
